import './PDP/featured-gallery';